import React from "react";
import {
  SEO,
  PageLayout,
  Section,
  DynamicTiles,
  MultipleComponentIterator,
  FishermanHeader,
  MarkdownContent,
  WebsiteComponentInteractions,
  SlideReveal,
  FullImageCard,
  InternalLink,
  FishermanIcon,
  FadeReveal,
  BasicCarousel,
  componentIterator,
  Image,
  multipleComponentIterator,
  ReviewV2,
  CustomerReviewModal,
  ScrollableContent,
  Location,
  Email,
  Phone,
  HoursOfOperation,
  ContinuousScrollV2,
  TeamMemberV2,
} from "@bluefin/components";
import { Button, Grid, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
  getComponentInteractions,
} from "../utils/utils";
import { createTeamMemberSlug } from "@bluefin/gatsby-plugin-fisherman-page-creator";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      dynamicTilesComponent,
      allFishermanBusinessLocation,
      allFishermanBusinessTeam,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          title={fishermanBusinessWebsitePage.seoTitle}
          ogUrl={"https://www.salon-bliss.com/"}
        />
        <PageLayout hero={false} subfooter={false} className={"home-page"}>
          <Section className={"custom-hero-section"}>
            <DynamicTiles className={"custom-hero"}>
              <MultipleComponentIterator
                iterator={dynamicTilesComponent.childConfigurations}
                components={[
                  {
                    component: (
                      <DynamicTiles.Tile
                        imageProps={{ loadStrategy: "eager" }}
                      />
                    ),
                    propMap: {
                      images: "files",
                      content: "contentNodes",
                      interactions: "interactions",
                      className: "data.className",
                      overlayClassName: "data.overlayClassName",
                      width: "data.width",
                      video: "data.video",
                    },
                  },
                ]}
              />
            </DynamicTiles>
          </Section>
          <Section className={"services-section"}>
            <FishermanHeader
              as={"h2"}
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_header",
                defaultValue: "Our Services",
              })}
            />
            <MarkdownContent
              content={getComponentContentNodeContent({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
            />
            <WebsiteComponentInteractions
              ctas={getComponentInteractions({
                components: fishermanBusinessWebsitePage.components,
                componentId: "services_section_description",
              })}
              alignment={"center"}
            />
            <Card.Group itemsPerRow={4}>
              <SlideReveal
                className={"ui card"}
                direction={"up"}
                triggerOnce={true}
                fade={true}
                key={"1"}
              >
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/f6b24a89d63c7f844b421907142b4bdb/fc98a/color.webp"
                  }
                  to={"/services/hair-services/"}
                  label={"Hair Services"}
                >
                  <Card.Header>
                    <span>Hair Services</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "From precision cuts and vibrant color to smoothing treatments and extensions, our hair services are tailored to bring out the best in your hair. Each appointment is a personalized experience, with your stylist giving you their full, undivided attention from start to finish."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/41ff8eb2cf58333d411fd7ff2484f848/fc98a/360_F_650799426_QqsQ2siFnp1WSiJZ3KYi3Utcnq3A5PWb.webp"
                  }
                  to={"/services/extensions-toppers/"}
                  label={"Extensions & Toppers"}
                >
                  <Card.Header>
                    <span>Extensions & Toppers</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Luxury extension services using premium, high-quality hair for seamless, natural results. Consultation required prior to booking."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/0f0a6d057efe464765364e35f629dbb1/3404b/style.webp"
                  }
                  to={"/services/smoothing-texture/"}
                  label={"Smoothing & Texture"}
                >
                  <Card.Header>
                    <span>Smoothing & Texture</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "From silky-smooth blowouts to lasting straightening treatments like Yuko and Brazilian Blowout, our smoothing and texture services help you manage frizz and transform your hair's natural texture. Each service is tailored to your hair's unique needs, so you leave feeling confident and completely at ease."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/84d06ddc6f964d75ca5357060f0c3fce/d8f44/jap_spa.webp"
                  }
                  to={"/services/head-spa/"}
                  label={"Head Spa"}
                >
                  <Card.Header>
                    <span>Head Spa</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "A head spa is a deeply relaxing scalp and hair treatment that combines therapeutic massage, nourishing care, and targeted techniques to restore balance to both your scalp and strands. It's a refined self-care ritual designed to leave you feeling refreshed from the inside out."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/1ededf53071e59848937c7bcaef4fa8b/222e3/dfb.webp"
                  }
                  to={"/services/facial/"}
                  label={"Facial"}
                >
                  <Card.Header>
                    <span>Facial</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Treat your skin to a moment of pure care with our facial services, designed to refresh, hydrate, and restore your natural glow. Each treatment is tailored to your skin's needs, so you leave feeling renewed from the inside out."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/364f582504c4879a059154249b8d4012/828a3/back.webp"
                  }
                  to={"/services/massage/"}
                  label={"Massage"}
                >
                  <Card.Header>
                    <span>Massage</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Settle into a state of total relaxation with our massage services, expertly tailored to melt away tension and restore your sense of ease. Each session is a personalized experience, giving you the attentive care you deserve."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/f3cd91e65f0a7490bc45da32f104326b/5d2e3/nails.webp"
                  }
                  to={"/services/tips-toes/"}
                  label={"Tips & Toes"}
                >
                  <Card.Header>
                    <span>Tips & Toes</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Treat yourself to a little luxury from fingertips to toes with our nail services, designed to leave you feeling polished and refreshed. Our attentive team brings the same personalized care to every appointment, so you can sit back, relax, and enjoy the experience."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
                <FullImageCard
                  as={InternalLink}
                  link={true}
                  event={{
                    category: "Services",
                    action: "View Category Details",
                  }}
                  className={"category-card"}
                  image={
                    "https://sites.gofisherman.com/salonblissspa/static/554059edb8ad8b8b3f6f956a6c9e6a99/f6e5c/z-OhifGPld6D2AGMxilUynC9NZm_c-ZhpDVOhyMe8sRd3c3-wUqp9vJTUQfoyu1im2gobkjLWcD37sXRigs0.webp"
                  }
                  to={"/services/bridal/"}
                  label={"Bridal"}
                >
                  <Card.Header>
                    <span>Bridal</span>
                    <FishermanIcon iconName={"arrow-right"} />
                  </Card.Header>
                  <MarkdownContent
                    className={"description"}
                    content={
                      "Luxury bridal hair and makeup services available in-salon or on location for you and your bridal party. To inquire please email our bridal coordinator at desk@salon-bliss.com."
                    }
                    isMarkdown={false}
                  />
                </FullImageCard>
              </SlideReveal>
            </Card.Group>
            <div className={"see-all-services-container"}>
              <Button
                primary={true}
                event={{ category: "Services", action: "View All Services" }}
                as={InternalLink}
                to={"/services/"}
              >
                <span
                  children={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentId: "see_all_services_button",
                    defaultValue: "Discover More Services",
                  })}
                />
              </Button>
            </div>
          </Section>
          <Section className={"about-section"}>
            <Grid stackable={true}>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <div>
                    <FishermanHeader
                      as={"h2"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_header",
                        defaultValue: "About Us",
                      })}
                    />
                    <FishermanHeader
                      as={"h3"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_subheader",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                    />
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "about_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            primary={true}
                            to={"/about/"}
                            as={InternalLink}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId: "see_more_about_button",
                              defaultValue: "Learn More About Us",
                            })}
                            event={{ category: "About", action: "View About" }}
                          />
                        </React.Fragment>
                      }
                    />
                  </div>
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={componentIterator({
                      iterator: getComponentFiles({
                        components: fishermanBusinessWebsitePage.components,
                        componentName: "ImageCollection",
                        componentIdentifier: "about_section_images",
                      }),
                      component: (
                        <Image
                          background={true}
                          className={"single-item-carousel-image"}
                        />
                      ),
                      propMap: { src: "__all__" },
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"reviews-section"}>
            <Image
              background={true}
              src={getComponentFiles({
                components: fishermanBusinessWebsitePage.components,
                componentIdentifier: "reviews_section_background_image",
                numToSelect: 1,
              })}
            >
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "reviews_section_header",
                  defaultValue: "What Our Clients Say",
                })}
              />
              <BasicCarousel
                size={1}
                displayIndicators={true}
                stepSize={1}
                autoScroll={false}
                leftArrowIcon={"arrow-left"}
                rightArrowIcon={"arrow-right"}
                displayPlayPauseButton={false}
                slide={true}
                items={multipleComponentIterator({
                  iterator: fishermanBusiness.reviews,
                  components: [
                    {
                      component: <ReviewV2 />,
                      propMap: { key: "_id" },
                      children: [
                        {
                          component: <ReviewV2.Text charLimit={440} />,
                          propMap: { text: "text" },
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Rating />,
                              propMap: { rating: "rating" },
                            },
                            {
                              component: <ReviewV2.RatingLabel />,
                              propMap: { rating: "rating" },
                            },
                          ],
                        },
                        {
                          component: <ReviewV2.Line />,
                          children: [
                            {
                              component: <ReviewV2.Author />,
                              propMap: { author: "author" },
                            },
                            {
                              component: <ReviewV2.Source />,
                              propMap: { source: "source", link: "link" },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                })}
              />
              <CustomerReviewModal
                businessId={fishermanBusiness._id}
                locations={allFishermanBusinessLocation.nodes}
                businessType={fishermanBusiness.type}
                triggerButtonProps={{ secondary: true }}
                buttonText={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "submit_review_button",
                  defaultValue: "Submit Review",
                })}
              />
            </Image>
          </Section>
          <Section className={"team-section"}>
            <ScrollableContent
              direction={"horizontal"}
              distanceFactor={"snap"}
              intervalFactor={500}
            >
              <Grid stackable={true} columns={2}>
                <Grid.Column className={"content-column"} width={4}>
                  <FishermanHeader
                    as={"h2"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_header",
                      defaultValue: "Our Team",
                    })}
                  />
                  <FishermanHeader
                    as={"h3"}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_subheader",
                      defaultValue: "Boost Your True Beauty",
                    })}
                  />
                  <MarkdownContent
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_description",
                    })}
                  />
                  <WebsiteComponentInteractions
                    ctas={getComponentInteractions({
                      components: fishermanBusinessWebsitePage.components,
                      componentId: "staff_section_description",
                    })}
                    fallback={
                      <div>
                        <Button
                          as={InternalLink}
                          to={"/team/?active-filter-tab=SHELBY+TOWNSHIP"}
                          primary={true}
                          content={"Shelby"}
                          className={"see-more-button"}
                          event={{
                            category: "Team",
                            action: "View Shelby Team Members",
                          }}
                        />
                        <Button
                          as={InternalLink}
                          to={"/team/?active-filter-tab=ROCHESTER+HILLS"}
                          primary={true}
                          content={"Rochester"}
                          className={"see-more-button"}
                          event={{
                            category: "Team",
                            action: "View Rochester Team Members",
                          }}
                        />
                      </div>
                    }
                  />
                  <div className={"triggers-container"}>
                    <ScrollableContent.PreviousTrigger />
                    <ScrollableContent.NextTrigger />
                  </div>
                </Grid.Column>
                <Grid.Column className={"team-member-cards-column"} width={12}>
                  <ScrollableContent.Content hideScrollbar={true}>
                    <MultipleComponentIterator
                      iterator={allFishermanBusinessTeam.nodes}
                      components={[
                        {
                          component: (
                            <FadeReveal
                              className={"ui card"}
                              triggerOnce={true}
                            />
                          ),
                          propMap: { key: "_id" },
                          children: [
                            {
                              component: (
                                <FullImageCard
                                  link={true}
                                  className={"team-member-card"}
                                  as={InternalLink}
                                  event={{
                                    category: "Team",
                                    action: "View Team Member",
                                  }}
                                />
                              ),
                              propMap: {
                                key: "_id",
                                image: "gatsbyImage",
                                to: createTeamMemberSlug,
                              },
                              children: [
                                {
                                  component: <TeamMemberV2.Name />,
                                  propMap: { name: "name" },
                                },
                                {
                                  component: <TeamMemberV2.Role />,
                                  propMap: { role: "role" },
                                },
                              ],
                            },
                          ],
                        },
                      ]}
                    />
                  </ScrollableContent.Content>
                  <div className={"actions-container"}>
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "staff_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            as={InternalLink}
                            to={"/team/"}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId: "see_all_team_button",
                              defaultValue: "See Our Team",
                            })}
                            className={"see-more-button"}
                            primary={true}
                          />
                        </React.Fragment>
                      }
                    />
                    <div className={"triggers-container"}>
                      <ScrollableContent.PreviousTrigger />
                      <ScrollableContent.NextTrigger />
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </ScrollableContent>
          </Section>
          <div
            className={"elfsight-app-db468683-e60b-4969-8dde-6b8570c1f2e5"}
            data-elfsight-app-lazy={true}
          />
          <Section className={"locations-section"}>
            <Grid columns={2} stackable={true}>
              <Grid.Column width={8} className={"carousel-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={0}>
                  <BasicCarousel
                    className={"locations-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={false}
                    autoScroll={false}
                    mobile={{ size: 1 }}
                    items={componentIterator({
                      iterator: getComponentFiles({
                        components: fishermanBusinessWebsitePage.components,
                        componentName: "ImageCollection",
                        componentIdentifier: "locations_section_images",
                      }),
                      component: (
                        <Image
                          background={true}
                          className={"single-item-carousel-image"}
                        />
                      ),
                      propMap: { src: "__all__" },
                    })}
                  />
                </FadeReveal>
              </Grid.Column>
              <Grid.Column width={8} className={"information-column"}>
                <FadeReveal duration={1250} triggerOnce={true} delay={450}>
                  <div className={"information-content"}>
                    <FishermanHeader
                      as={"h2"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_header",
                      })}
                    />
                    <FishermanHeader
                      as={"h3"}
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_subheader",
                      })}
                    />
                    <MarkdownContent
                      content={getComponentContentNodeContent({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_description",
                      })}
                    />
                    <WebsiteComponentInteractions
                      ctas={getComponentInteractions({
                        components: fishermanBusinessWebsitePage.components,
                        componentId: "locations_section_description",
                      })}
                      fallback={
                        <React.Fragment>
                          <Button
                            primary={true}
                            as={InternalLink}
                            to={"/locations/"}
                            content={getComponentContentNodeContent({
                              components:
                                fishermanBusinessWebsitePage.components,
                              componentId: "see_all_locations_button",
                              defaultValue: "Discover Our Locations",
                            })}
                            event={{
                              category: "Locations",
                              action: "View Locations",
                            }}
                          />
                        </React.Fragment>
                      }
                    />
                  </div>
                  <Card.Group className={"locations-cards"}>
                    <MultipleComponentIterator
                      iterator={allFishermanBusinessLocation.nodes}
                      components={[
                        {
                          component: <Card />,
                          propMap: { key: "_id" },
                          children: [
                            {
                              component: <Card.Content />,
                              children: [
                                {
                                  component: <Card.Header />,
                                  propMap: { content: "name" },
                                },
                                {
                                  component: <Card.Description />,
                                  children: [
                                    {
                                      component: <Location inline={true} />,
                                      propMap: {
                                        "address.street": "street",
                                        "address.city": "city",
                                        "address.state": "state",
                                        "address.zip": "zipCode",
                                      },
                                    },
                                    {
                                      component: <Email />,
                                      propMap: { email: "email" },
                                    },
                                    {
                                      component: <Phone />,
                                      propMap: { phone: "phoneNumber" },
                                    },
                                  ],
                                },
                                {
                                  component: (
                                    <HoursOfOperation
                                      displayOption={"dailyWithPopup"}
                                    />
                                  ),
                                  propMap: { hours: "hours" },
                                },
                              ],
                            },
                          ],
                        },
                      ]}
                    />
                  </Card.Group>
                </FadeReveal>
              </Grid.Column>
            </Grid>
          </Section>
          <Section className={"trusted-by-section"}>
            <div className={"content-container"}>
              <FishermanHeader
                as={"h2"}
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_header",
                })}
              />
              <MarkdownContent
                content={getComponentContentNodeContent({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_description",
                })}
              />
              <WebsiteComponentInteractions
                ctas={getComponentInteractions({
                  components: fishermanBusinessWebsitePage.components,
                  componentId: "trusted_by_section_description",
                })}
              />
            </div>
            <ContinuousScrollV2
              loadStrategy={"inViewport"}
              sizePatterns={[{ width: 100, height: 50, alignment: "middle" }]}
              items={multipleComponentIterator({
                iterator: getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "ImageCollection",
                  componentIdentifier: "trusted_by_images",
                }),
                components: [
                  {
                    component: <ContinuousScrollV2.Item />,
                    propMap: { key: "_id" },
                    children: [
                      {
                        component: <Image loadStrategy={"eager"} />,
                        propMap: { src: "__all__" },
                      },
                    ],
                  },
                ],
              })}
            />
          </Section>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      reviews {
        _id
        author
        text
        source
        rating
        link
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          _id
        }
        contentNodes {
          content
        }
        interactions {
          _id
          order
          behaviorType
          displayType
          enabled
          label
          style
          url
          role
        }
      }
      seoTitle
    }
    dynamicTilesComponent: fishermanWebsiteComponent(
      page: { pageType: { eq: "Home" } }
      fastId: { eq: "DynamicTiles" }
    ) {
      childConfigurations {
        data {
          className
          overlayClassName
          width
          video {
            videoId
            url
            source
            placeholder
          }
        }
        files {
          _id
          altText
          file
          order
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        contentNodes {
          _id
          content
          contentType
          contentName
          order
        }
        interactions {
          _id
          displayType
          behaviorType
          enabled
          label
          order
          style
          url
        }
      }
    }
    allFishermanBusinessLocation {
      nodes {
        _id
        street
        city
        name
        phoneNumber
        primaryLocation
        state
        zipCode
        email
        hours {
          open
          close
          day
          label
        }
      }
    }
    allFishermanBusinessTeam(
      sort: { order: ASC, fields: order }
      filter: { show: { eq: true } }
    ) {
      nodes {
        _id
        name
        role
        group
        email
        phone
        description
        image
        gatsbyImage {
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
        socialMedia {
          platform
          url
        }
        hours {
          startDay
          openTime
          closeTime
        }
        locations {
          _id
          name
        }
        show
      }
    }
  }
`;
